import { createIcon } from "@chakra-ui/icons";

// Created from mapPin.svg

export const MapPinIcon = createIcon({
  displayName: "MapPin",
  viewBox: "0 0 25 25",
  path: (
    <g>
      <path
        d="M21.209 10.6025C21.209 17.6025 12.209 23.6025 12.209 23.6025C12.209 23.6025 3.20898 17.6025 3.20898 10.6025C3.20898 8.21559 4.1572 5.92641 5.84502 4.23858C7.53285 2.55075 9.82204 1.60254 12.209 1.60254C14.5959 1.60254 16.8851 2.55075 18.5729 4.23858C20.2608 5.92641 21.209 8.21559 21.209 10.6025Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.209 13.6025C13.8658 13.6025 15.209 12.2594 15.209 10.6025C15.209 8.94568 13.8658 7.60254 12.209 7.60254C10.5521 7.60254 9.20898 8.94568 9.20898 10.6025C9.20898 12.2594 10.5521 13.6025 12.209 13.6025Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </g>
  ),
});
